import { useLocation } from 'react-router-dom';

export interface QueryParams {
  concentration: string | null;
  desiredDosage: string | null;
  ousiaVialDosage: string | null;
  zepboundListedDosage: string | null;
  units: string | null;
  weeklyDose: string | null;
  frequency: string | null;
}

export function useQueryParams(): QueryParams {
  const query = new URLSearchParams(useLocation().search);
  const concentration = query.get('c');
  const desiredDosage = query.get('d');
  const ousiaVialDosage = query.get('v');
  const zepboundListedDosage = query.get('z');
  const units = query.get('u');
  const weeklyDose = query.get('weeklyDose');
  const frequency = query.get('frequency');
  return { concentration, desiredDosage, ousiaVialDosage, zepboundListedDosage, units, weeklyDose, frequency };
}
